import React, { useEffect, useRef } from "react";

function Pagefour() {
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: "0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = "1";
          entry.target.style.transform = "translateY(0)";
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((ref) => {
      if (ref) {
        ref.style.opacity = "0";
        ref.style.transform = "translateY(50px)";
        observer.observe(ref);
      }
    });

    return () => observer.disconnect();
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  return (
    <div
      style={{
        padding: "80px 20px",
        backgroundColor: "#ffffff",
        color: "#1f3121",
        overflow: "hidden",
      }}
    >
      {/* Hero Section */}
      <div
        ref={addToRefs}
        style={{
          textAlign: "center",
          maxWidth: "1200px",
          margin: "0 auto 80px",
          transition: "all 0.8s ease-out",
        }}
      >
        <h1
          style={{
            fontSize: "56px",
            fontWeight: "800",
            marginBottom: "24px",
            color: "#0693e3",
          }}
        >
          Where Business Meets Brilliance 🚀
        </h1>
        <p
          style={{
            fontSize: "20px",
            lineHeight: "1.8",
            color: "#4a4a4a",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          Imagine a command center for your business Qbicles is the powerhouse
          that connects every corner of your operations. From managing processes
          to boosting collaboration, it's the smarter way to run things.
        </p>
      </div>

      {/* Features Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "30px",
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "40px 0",
        }}
      >
        {[
          {
            icon: "🌟",
            title: "All-in-One Workspace",
            description:
              "Keep an eye on everything happening in your business, in one sleek and intuitive space.",
          },
          {
            icon: "⚡",
            title: "Supercharge Productivity",
            description:
              "Collaborate effortlessly and streamline processes like purchases, so you can focus on what matters.",
          },
          {
            icon: "🔒",
            title: "Built-in Fraud Fighter",
            description:
              "Spot and solve procurement issues before they turn into costly mistakes.",
          },
          {
            icon: "💡",
            title: "Smarter Spending",
            description:
              "Get crystal-clear insights into your purchases and make better financial decisions with ease.",
          },
          {
            icon: "🤝",
            title: "Seamless Integration",
            description:
              "Works hand-in-hand with your favorite business tools for maximum efficiency.",
          },
          {
            icon: "🚀",
            title: "Scale with Ease",
            description:
              "Whether you're a startup or an enterprise, Qbicles grows with you, adapting to your evolving needs and ambitions.",
          },
        ].map((feature, index) => (
          <div
            key={index}
            ref={addToRefs}
            style={{
              padding: "40px",
              backgroundColor: "#f8f9fa",
              borderRadius: "20px",
              transition: "all 0.6s ease-out",
              transform: "translateY(50px)",
              opacity: 0,
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
              transitionDelay: `${index * 0.1}s`,
            }}
          >
            <div style={{ fontSize: "40px", marginBottom: "20px" }}>
              {feature.icon}
            </div>
            <h3
              style={{
                fontSize: "24px",
                marginBottom: "16px",
                color: "#1f3121",
              }}
            >
              {feature.title}
            </h3>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
                color: "#4a4a4a",
              }}
            >
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div
        ref={addToRefs}
        style={{
          textAlign: "center",
          maxWidth: "800px",
          margin: "80px auto 0",
          padding: "60px",
          backgroundColor: "#0693e3",
          borderRadius: "30px",
          color: "white",
          transition: "all 0.8s ease-out",
          transform: "translateY(50px)",
          opacity: 0,
        }}
      >
        <h2
          style={{
            fontSize: "36px",
            marginBottom: "24px",
          }}
        >
          Ready to redefine your Business?
        </h2>
        <p
          style={{
            fontSize: "18px",
            marginBottom: "32px",
            color: "#e0e0e0",
          }}
        >
          Let's Qbicle it! 🌐
        </p>
        <button
          style={{
            backgroundColor: "#ffffff",
            color: "#1f3121",
            padding: "16px 32px",
            border: "none",
            borderRadius: "12px",
            fontSize: "18px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.05)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          Get Started Now
        </button>
      </div>
    </div>
  );
}

export default Pagefour;
